import WindowElement from './window-element';

export default WindowElement;